export default "__VITE_ASSET__CaRfuJr5__"